<template>
    <div>
        <!-- <vue-headful v-bind:title="$t('about.metadata.title')" v-bind:description="$t('about.metadata.description')" ogLocale="sv_SE" lang="sv-SE"/>         -->
        
        <Hero img="/images/conference-room.jpeg" v-bind:title="$t('about.hero.title')" v-bind:preamble="$t('about.hero.preamble')" v-bind:body="$t('about.hero.body')" />

        <section id="personnel">
            <div class="container">
                <div class="section-content">
                    <div class="text-area">
                        <h2>{{$t('about.content.upper.title')}}</h2>
                        <p v-for="(data, index) in $t('about.content.upper.texts')" :key="index">{{data.text}}</p>
                        <div class="card-deck">
                            <Person v-for="(data, index) in $t('about.persons')" :key="index" :img=data.img :title=data.name :subtitle=data.role :text=data.text :index=index />
                        </div>
                        <h2>{{$t("about.content.lower.title")}}</h2>
                        <p>{{$t("about.content.lower.text")}}</p>
                   </div>
               </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Hero from '../components/Hero.vue'
    import Person from '../components/Person'

    export default {
        name: 'app',
        components: {
            Hero,
            Person
        }
    }
</script>

<style scoped>
    @media (min-width: 768px) {
        .card-deck {
            padding-top: 3rem;
            margin: auto;
            max-width: 780px;
        }
    }

    @media (min-width: 1200px) {
        .card-deck {
            margin: auto;
            max-width: 820px;
        }
    }
    .card-columns {
            column-count: 3;
    }
</style>